import Vue from 'vue'
import Vuex from 'vuex'
import { routes as ModuleRoutes, stores as ModuleStores, menus as ModuleMenus } from '@/modules'
import config from './config';
import {helpers} from './helpers';

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    //состояние правой панели
    rightPanel: false,
    //стили правой панели
    rightPanelStyle: {},
    //размер центральной панели
    centralFlexSize: 'big',
    //url бэкенда
    endpoint: config.main.endpoint,
    staticEndpoint: config.main.staticEndpoint,
    //флаг показа прогресс бара в верхней части сайта (false - скрыт, true - показан)
    progress: false,
    progressObj: {},
    snackbar: {
      show: false,
      duration: 4000,
      message: '',
      type: 'default'
    }
  },
  mutations: {
    setStateObject(state, options) {
      let string = options[0];
      let values = options[1];
      let object = state;
      string.split('.').forEach(function(item) {
        if (typeof object[item] == 'undefined' || !object[item]) Vue.set(object, item, {});
        object = object[item];
      });
      for(let key in values) {
        if (values.hasOwnProperty(key)) Vue.set(object, key, values[key]);
      }
    },
    addStateObject(state, options) {
      let string = options[0];
      let values = options[1];
      let object = state;
      string.split('.').forEach(function(item) {
        object = object[item]
      });
      object.push(values);
    },
    deleteStateObject(state, options) {
      let string = options[0];
      let index = options[1];
      let object = state;
      string.split('.').forEach(function(item) {
        object = object[item];
      });
      object.splice(index, 1);
    },
    openRightPanel(state) {
      state.rightPanel = true
    },
    closeRightPanel(state) {
      state.rightPanel = false
    },
    setRightPanelWidth(state, width) {
      if (typeof width !== 'undefined') state.rightPanelStyle.width = parseInt(width) + 'px';
      else delete state.rightPanelStyle.width;
    },
    setBigSizePanel(state) {
      state.centralFlexSize = 'big'
    },
    setMediumSizePanel(state) {
      state.centralFlexSize = 'medium'
    },
    setSmallSizePanel(state) {
      state.centralFlexSize = 'small'
    },
    adaptiveSizePanel(state) {
      let documentRect = document.querySelector('body').getBoundingClientRect();
      if (documentRect.width < 1440) state.centralFlexSize = 'medium';
      else state.centralFlexSize = 'big';
    },
    toggleProgressBar(state, code) {
        if (code) {
          let progressObj = Object.assign({}, state.progressObj);
          if (progressObj[code]) progressObj[code] = !progressObj[code];
          else progressObj[code] = false;
          Vue.set(state, 'progressObj', state.progressObj);
        } else state.progress = !state.progress;
    },
    showProgressBar(state, code) {
        if (code) {
          let progressObj = Object.assign({}, state.progressObj);
          progressObj[code] = true;
          Vue.set(state, 'progressObj', progressObj);
        } else state.progress = true;
    },
    hideProgressBar(state, code) {
      if (code) {
          let progressObj = Object.assign({}, state.progressObj);
          progressObj[code] = false;
          Vue.set(state, 'progressObj', progressObj);
      } else state.progress = false;
    },
    showSnackbar(state, data) {
      if (!data || !data[0]) return;
      let timeOut = (data[1]) ? data[1] : 4000,
          type    = (data[2]) ? data[2] : 'default';

      type = (['default', 'error', 'success'].indexOf(type)+1) ? type : 'default';

      state.snackbar.duration = timeOut;
      state.snackbar.message = data[0];
      state.snackbar.show = true;
      state.snackbar.type = type;

      setTimeout(() => {
        state.snackbar.show = false;
        state.snackbar.message = '';
      }, 0);

      /*
      setTimeout(function () {
        state.snackbar.show = false;
        state.snackbar.message = '';
      }, timeOut);
      */
    },
    hideSnackbar(state){
      state.snackbar.show = false;
      state.snackbar.message = '';
    },
    handleSnackError(state, data) {
      if (!data || !Array.isArray(data)) return;
      let [response, time, type] = data;
      if (!time) time = 6000;

      let message = (response && response.body && response.body.errors && response.body.errors.messages) 
        ? response.body.errors.messages 
        : 'Произошла неизвестная ошибка. Пожалуйста перезагрузите страницу и обратитесь к администратору.';

      this.commit('showSnackbar', [message, time, type]);
    },
    setTitle(state, title) {
      Vue.set(state, 'pageTitle', title)
    },
    setPrint(state, print) {
      if (typeof print != 'boolean') Vue.set(state, 'print', false)
      else Vue.set(state, 'print', print)
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('tasks/init');
    },
    getVersionChanges({ state, dispatch, rootState }) {
      return helpers.http.get({context: this, rootState}, '/version_changes').then(r => r ? r.bodyText : '');
    },
  },
  modules: ModuleStores
})



// WEBPACK FOOTER //
// ./src/store.js